import { api } from "@/APIRequests";
import type { GenerateOtcResponse } from "@/core/types";

export async function generateOtc({
  patientId,
}: {
  patientId: string;
}): Promise<GenerateOtcResponse> {
  return api.sharedTyped.generate_otc({
    params: { showLoader: false },
    patientId,
  });
}
